module.exports = __webpack_public_path__ + "static/img/16.7918de2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/12/sp/16.png
// module id = /HZY
// module chunks = 0